import { Pipe, PipeTransform } from '@angular/core';
import { MoteurOperateurDto } from 'src/graphql/generated-types';

@Pipe({
    name: 'filteredComparisonOperatorList',
    standalone: false
})
export class FilteredComparisonOperatorListPipe implements PipeTransform {
    static format(comparisonOperatorList: MoteurOperateurDto[], isEqualOperator: boolean): MoteurOperateurDto[] {
        return isEqualOperator
            ? comparisonOperatorList.filter(c => ['=', '<>'].includes(c.Libelle))
            : comparisonOperatorList;
    }

    transform(comparisonOperatorList: MoteurOperateurDto[], isEqualOperator: boolean): MoteurOperateurDto[] {
        return FilteredComparisonOperatorListPipe.format(comparisonOperatorList, isEqualOperator);
    }
}
